import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/download_pattern_left.png'
import _imports_1 from '@/assets/images/download_pattern_right.png'
import _imports_2 from '@/assets/images/icon/icon_earth_blue.png'
import _imports_3 from '@/assets/images/ic_launcher_1.png'
import _imports_4 from '@/assets/images/ic_launcher_2.png'
import _imports_5 from '@/assets/images/ic_launcher_3.png'
import _imports_6 from '@/assets/images/icon/icon_iphone.png'
import _imports_7 from '@/assets/images/icon/icon_android.png'


const _hoisted_1 = { class: "app-download" }
const _hoisted_2 = { class: "lang-box" }
const _hoisted_3 = { class: "lang-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title-box" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "imgdiv" }
const _hoisted_9 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_10 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"border-radius":"15px"}
}
const _hoisted_11 = {
  key: 2,
  src: _imports_5,
  alt: "",
  style: {"border-radius":"15px"}
}
const _hoisted_12 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_13 = { class: "down-box" }
const _hoisted_14 = { class: "btn-item" }
const _hoisted_15 = { class: "btn-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "pattern left" }, [
      _createElementVNode("img", { src: _imports_0 })
    ], -1)),
    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "pattern right" }, [
      _createElementVNode("img", { src: _imports_1 })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "lang-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeLang = !$setup.changeLang))
      }, [
        _createElementVNode("span", null, _toDisplayString($setup.language), 1),
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_2,
          width: "23",
          height: "23",
          alt: ""
        }, null, -1))
      ]),
      _withDirectives(_createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lanArr, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass({ active: $setup.activeIndex === index }),
            onClick: ($event: any) => ($setup.changeLanguage(item, index)),
            key: index
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ], 512), [
        [_vShow, $setup.changeLang]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString($setup.title), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("download.desc") + $setup.title + _ctx.$t("download.desc2")), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      ($setup.appId == 1)
        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
        : ($setup.appId == 2)
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : ($setup.appId == 3)
            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
            : (_openBlock(), _createElementBlock("img", _hoisted_12))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", {
          class: "down-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.downJump('iphone')))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: _imports_6,
            width: "23px",
            alt: ""
          }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("i", null, "iPhone", -1)),
          _createElementVNode("em", null, _toDisplayString(_ctx.$t("download.down")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", {
          class: "down-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.downJump('android')))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: _imports_7,
            width: "27px",
            alt: ""
          }, null, -1)),
          _cache[7] || (_cache[7] = _createElementVNode("i", null, "Android", -1)),
          _createElementVNode("em", null, _toDisplayString(_ctx.$t("download.down")), 1)
        ])
      ])
    ])
  ]))
}